import { SOCK_COLORS, SockColor, sockFrequency } from './laundry_game_defs';
import SockIndicator from './SockIndicator';

interface ScoreBarProps {
    caughtSocks: SockColor[];
}

function ScoreBar(props: ScoreBarProps): JSX.Element {
    const { caughtSocks } = props;

    const frequency = sockFrequency(caughtSocks);

    return (
        <div className="score-bar">
            {SOCK_COLORS.map((color: SockColor) => (
                <SockIndicator
                    key={color}
                    color={color}
                    count={frequency.get(color) ?? 0}
                />
            ))}
        </div>
    );
}

export default ScoreBar;
